import React, { Component, cloneElement, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { updateSignUpProps, clearSignUpStore, checkCompanyName, submitSignUp } from '../../stores/sign-up/sign-up-actions';
const logoGlobeSrc = require('../../../www/images/tourconnect-logo-globe.svg');
const logoNameSrc = require('../../../www/images/tourconnect-logo-name.svg');
import { onUserInput } from '../../stores/userInputActions';
import { signUpActions } from '../../stores/sign-up/sign-up-constants';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import muiTheme from '../../utils/muiTheme';
import moment from 'moment-timezone';

class SignUpContainer extends Component {
  componentWillMount() {
    if (moment.tz.guess()) {
      this.props.dispatchedUpdateProps({ region: moment.tz.guess() });
    }
    if (this.props.location.query.email) {
      this.props.dispatchedUpdateProps({ email: this.props.location.query.email });
    }
    if (this.props.location.query.companyId) {
      this.props.dispatchedUpdateProps({
        MMCompanyToView: this.props.location.query.companyId,
        email: this.props.location.query.email,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearSignUpStore();
  }

  goToStep = step => {
    const { virtualPageView } = this.props;
    switch (step) {
      case 1:
        virtualPageView('/signup');
        break;
      case 2:
        virtualPageView('/signup/reason');
        break;
      case 3:
        virtualPageView('/signup/operation');
        break;
      case 4:
        virtualPageView('/signup/account');
        break;
      default:
    }
    this.props.dispatchedUpdateProps({ step });
  }

  checkCompanyNameFunc = () => {
    return this.props.updateCompany(this.props.signup.companyName, this.props.signup.selectedCompanyType);
  };

  submitSignUpAction = payload => this.props.submitSignUpAction(payload).then(() => {
    this.props.virtualPageView('/signup/confirmation');
  });

  render() {
    const {
      dispatchedUpdateProps,
      children,
      ...props,
    } = this.props;

    const extraProps = {
      onUserInput,
      dispatchedUpdateProps,
      goToStep: this.goToStep,
      checkCompanyName: this.checkCompanyNameFunc,
      ...props,
      submitSignUpAction: this.submitSignUpAction,
    };

    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div>
          <div className="app-bar is-not-logged-in">
            <div className="app-bar-content">
              <Link className="tourconnect-logo" to="/">
                <img
                  className="tourconnect-logo-globe"
                  src={logoGlobeSrc}
                />
                <img
                  className="tourconnect-logo-name"
                  src={logoNameSrc}
                  alt="tourconnect"
                />
              </Link>
            </div>
          </div>
          {children ? cloneElement(children, extraProps) : undefined}
        </div>
      </MuiThemeProvider>
    );
  }
}

SignUpContainer.propTypes = {
  children: PropTypes.object,
  clearSignUpStore: PropTypes.func,
  companyName: PropTypes.string,
  dispatch: PropTypes.func,
  dispatchedUpdateProps: PropTypes.func,
  location: PropTypes.object,
  signup: PropTypes.object,
  submitSignUpAction: PropTypes.func,
  updateCompany: PropTypes.func,
  updateSignUpProps: PropTypes.func,
  virtualPageView: PropTypes.func,
};

const mapStateToProps = state => ({
  signup: state.signup.toJS(),
  step: state.signup.get('step'),
});

const mapDispatchToProps = dispatch => ({
  updateCompany: (name, type) => dispatch(checkCompanyName(name, type)),
  submitSignUpAction: payload => dispatch(submitSignUp(payload)),
  dispatchedUpdateProps: (...args) => dispatch(updateSignUpProps(...args)),
  clearSignUpStore: () => dispatch(clearSignUpStore()),
  virtualPageView: (path) => dispatch({ type: 'PAGE_VIEW', payload: { path } }),
  checkOneCompanyType: onUserInput(dispatch, signUpActions, 'checkCompanyType'),
  uncheckOneCompanyType: onUserInput(dispatch, signUpActions, 'uncheckCompanyType'),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpContainer);



// WEBPACK FOOTER //
// ./src/app/components/signup/signup-container.jsx